export default __webpack_public_path__ + "static/media/maurice.ae75aaea.webp";